import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import ExternalImageForUrl from "src/components/images/ExternalImageForUrl";
import { getOrgSizeForImageUrl } from "src/components/images/imageFunctions";
import { type Movie } from "src/lib/movieinfo/movieinfotypes";
import styles from './MoviePosterImage.module.css';

//#region [Props]
type MoviePosterImageProps = {
  movie: Movie;
  className?: string;
  missingPosterOffCentre?: boolean;
};
//#endregion

//#region [Component]
export default function MoviePosterImage(t0) {
  const $ = _c(26);
  const {
    movie,
    className,
    missingPosterOffCentre: t1
  } = t0;
  const missingPosterOffCentre = t1 === undefined ? false : t1;
  const t2 = movie?.sanityImagePosterUrl as string | undefined;
  let t3;
  if ($[0] !== t2) {
    t3 = getOrgSizeForImageUrl(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const size = t3;
  const hasPoster = !!movie.sanityImagePosterUrl && (size?.aspect ?? 1) < 1;
  const hasExternalPoster = !hasPoster && !movie.mainVersionId && !!movie.externalImagePosterUrl;
  const t4 = !hasPoster;
  let t5;
  if ($[2] !== className || $[3] !== hasExternalPoster || $[4] !== t4) {
    t5 = classNames(styles.SPosterSizer, {
      [styles.EmptyAspect]: t4,
      [styles.FixedImageHeight]: hasExternalPoster
    }, className);
    $[2] = className;
    $[3] = hasExternalPoster;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = size?.aspect;
  let t7;
  if ($[6] !== hasPoster || $[7] !== movie.sanityImagePosterUrl || $[8] !== movie.title) {
    t7 = hasPoster && <CmsImageForUrl imageUrl={movie.sanityImagePosterUrl} alt={`Plakat for ${movie.title}`} height={254} className={styles.FixedImageHeight} unoptimized={true} />;
    $[6] = hasPoster;
    $[7] = movie.sanityImagePosterUrl;
    $[8] = movie.title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== hasExternalPoster || $[11] !== hasPoster || $[12] !== movie.externalImagePosterUrl || $[13] !== movie.title) {
    t8 = !hasPoster && hasExternalPoster && <ExternalImageForUrl imageUrl={movie.externalImagePosterUrl} alt={`Plakat for ${movie.title}`} className={styles.SExternalPosterImage} />;
    $[10] = hasExternalPoster;
    $[11] = hasPoster;
    $[12] = movie.externalImagePosterUrl;
    $[13] = movie.title;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== hasExternalPoster || $[16] !== hasPoster || $[17] !== missingPosterOffCentre || $[18] !== movie.title) {
    t9 = !hasPoster && !hasExternalPoster && <div data-postermissingtext="Plakat mangler" className={classNames(styles.SMissingPoster, styles.FixedImageHeight, styles.EmptyAspect, {
      [styles.offCentre]: missingPosterOffCentre
    })}>{movie.title}</div>;
    $[15] = hasExternalPoster;
    $[16] = hasPoster;
    $[17] = missingPosterOffCentre;
    $[18] = movie.title;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t10 = <div className={t5} data-aspect={t6}>{t7}{t8}{t9}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
//#endregion

//#region [Styles]
// Moved to MoviePosterImage.module.css
//#endregion